import { gsap } from 'gsap'
import Swiper from 'swiper';
import 'swiper/css';
import { Pagination, Autoplay, Navigation } from 'swiper/modules';

export default {
  init() {
    console.log('home');
    
    const barFill = document.querySelector(".autoplay-bar-fill");

    const swiper = new Swiper(".swiperProgetti", {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      autoplay: {
        delay: 4000, 
      },
      modules: [Pagination, Autoplay, Navigation],
      on: {
        autoplayTimeLeft(s, time, progress) {
          
          // progress va da 1 (inizio) a 0 (fine)
          const pct = (1 - progress) * 100;

          barFill.style.width = pct + "%";
        },

        slideChange() {
            // reset immediato al cambio slide
            barFill.style.transition = "none";
            barFill.style.width = "0%";
            requestAnimationFrame(() => {
                barFill.style.transition = "width linear";
            });
        }
      }
    });


  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};
